import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { StoreService } from '../service/store-service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-add-store-type',
  templateUrl: './add-store-type.component.html',
  styleUrls: ['./add-store-type.component.css']
})
export class AddStoreTypeComponent {
  storeForm!: FormGroup;
  isLoading: boolean = false;
  constructor(
    private fb: FormBuilder,
    private storeService: StoreService,
    private snackBar: MatSnackBar,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.storeForm = this.fb.group({
      businessAreaId: [localStorage.getItem("businessAreaId")],
      btn_name: ['STORE_TYPE_ADD'],
      storeType: ['', Validators.required],
      aliasName: ['', Validators.required],
      description: ['', Validators.required],
      remarks: ['', Validators.required],
      createdBy: [localStorage.getItem("userId")]
    });
  }

  onSubmit() {
    this.isLoading = true;
    if (this.storeForm.invalid) {
      this.snackBar.open('Please fill all required fields', 'Close', { duration: 3000 });
      return;
    }

    const payload = this.storeForm.value;

    this.storeService.addStoreType(payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        Swal.fire({
          icon: 'success',
          title: 'Success!',
          text: 'Store Type Added Successfully',
          confirmButtonColor: '#3085d6'
        });

        this.router.navigate(['/coremodule/StoreLocation']);
      },
      error: (err) => {
        this.isLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong!',
          confirmButtonColor: '#d33'
        });

      }
    });
  }

  onReset() {
    this.storeForm.reset({
      btn_name: 'STORE_TYPE_ADD',
      businessAreaId: localStorage.getItem("businessAreaId"),
      createdBy: localStorage.getItem("userId")
    });
  }

  onBack() {
    this.router.navigate(['/coremodule/StoreLocation']);
  }
}
